import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { zIndex } from '../theme/constants';
import { focusStyle } from '../styles/mixins';
import { StylesIndexInjections, isMobileApp } from 'common-react';

export interface TooltipStyleProps {
  customZIndex?: number;
}
const mobileBottomPadding = 28;
const getMobileAppBottomPadding = (theme: Theme) =>
  mobileBottomPadding + theme.space.mobileBottomPadding();
export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    zIndex: ({ customZIndex }: TooltipStyleProps) => customZIndex || 6,
    cursor: 'pointer',
  },

  tooltip: {
    padding: '4px 8px',
    color: theme.color.greys[0],
    backgroundColor: theme.color.greys[80],
    border: `1px solid ${theme.color.greys[80]}`,
    background: theme.color.greys[80],
    borderRadius: 4,
    margin: '0 0 8px 0',
  },


  arrow: {
    color: theme.color.greys[80],
    '&:before': {
      border: `1px solid ${theme.color.greys[80]}`,
    }
  },

  tooltipIcon: {
    width: 16,
    height: 16,
    cursor: 'help',
    color: theme.color.greys[80],
  },

  infoOrangeIcon: {
    color: theme.color.oranges[50],
  },

  fullIcon: {
    color: theme.color.greys[80],
  },
  fullOrangeIcon: {
    color: theme.color.oranges[50],
  },
  errorIcon: {
    color: theme.color.oranges[50],
    '&:hover': {
      color: theme.color.greys[70],
    },
  },

  tooltipWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  tooltipPreTitle: {
    color: theme.color.greys[0],
  },

  tooltipTitle: {
    color: theme.color.greys[0],
  },

  button: {
    display: 'flex',
    margin: 0,
    padding: 0,
    border: 0,
    background: 'none',
    cursor: 'pointer',

    '&:focus-visible': {
      ...focusStyle(theme),
    },
  },

  dialog: {
    '& .MuiPaper-root': {
      marginBottom: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      margin: 0,
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        top: 'auto',
        borderBottomRightRadius: '0 !important',
        borderBottomLeftRadius: '0 !important',
      },
    },
    '& .MuiDialogContent-root': {
      padding: 0,
    },
    [theme.breakpoints.down('sm')]: {
      '& $dialogPaperInner': {
        padding: '60px 16px 28px',
        paddingBottom: isMobileApp()
          ? getMobileAppBottomPadding(theme)
          : mobileBottomPadding,
      },
      '& $dialogContentWrapper': {
        padding: 0,
      },
    },
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: zIndex.modalZIndex,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    padding: 0,
    background: 'none',
    border: `1px solid ${theme.color.greys[15]}`,
    borderRadius: '50%',
    cursor: 'pointer',
    color: theme.color.greys[75],
    '& svg': {
      width: 12,
      height: 12,
    },
    '&:focus-visible': {
      ...focusStyle(theme),
    },
  },

  closeIcon: {
    width: 24,
    height: 24,
    padding: 5,

    '& path': {
      fill: theme.color.greys[80]
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },

  dialogCard: {
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: '0 !important',
    },
  },

  dialogPaperInner: {},
  dialogContentWrapper: {},
}), { name: 'Tooltip', index: StylesIndexInjections.OTHER });
